import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const solutionLinks = [
    { name: t('footer.dieselGenerators'), href: '#diesel-generators' },
    { name: t('footer.batteryStorage'), href: '#battery-storage' },
    { name: t('footer.cogeneration'), href: '#cogeneration' },
    { name: t('footer.transformers'), href: '#transformers' },
    { name: t('footer.switchgears'), href: '#switchgears' },
    { name: t('footer.ems'), href: '#ems' }
  ];

  return (
    <footer className="bg-[#0c0c0c] border-t border-[#1a1a1a]" role="contentinfo">
      {/* Main footer content - compact */}
      <div className="py-8 px-4">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 items-start">
            {/* Company info */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start space-x-2 mb-3">
                <div className="w-8 h-8 bg-accent-green rounded flex items-center justify-center">
                  <span className="text-tech-dark font-bold text-sm">FBS</span>
                </div>
                <span className="text-white font-bold">Group</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                {t('footer.companyDesc')}
              </p>
            </div>

            {/* Riešenia links */}
            <nav aria-label={t('footer.solutionsTitle')} className="text-center md:text-left">
              <h4 className="text-white font-semibold mb-3 text-sm">{t('footer.solutionsTitle')}</h4>
              <ul className="space-y-1.5">
                {solutionLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className="text-gray-400 hover:text-accent-green transition-colors duration-200 text-sm">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Contact info */}
            <div className="text-center md:text-left">
              <h4 className="text-white font-semibold mb-3 text-sm">{t('footer.contactTitle')}</h4>
              <div className="space-y-1.5 text-sm">
                <div className="text-gray-400">📍 Tatranská Lomnica 14649, 059 60 Vysoké Tatry</div>
                <div className="text-gray-400">📞 +421 904 644 464</div>
                <div className="text-gray-400">✉️ info@fbsgroup.sk</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#1a1a1a] py-4">
        <div className="container-custom">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
            <div className="text-gray-500 text-xs">
              © {currentYear} FBS group. {t('footer.allRights')} | Created by <a href="https://wavelynecode.com" target="_blank" rel="noopener noreferrer" className="text-accent-green hover:text-[#d4ff33] transition-colors duration-200">Wavelyne</a>
            </div>
            <nav aria-label="Legal" className="flex items-center space-x-4 text-xs">
              <a href="/ochrana-udajov" className="text-gray-500 hover:text-accent-green transition-colors duration-200">{t('footer.dataProtection')}</a>
              <a href="/cookies" className="text-gray-500 hover:text-accent-green transition-colors duration-200">{t('footer.cookies')}</a>
              <a href="/gdpr" className="text-gray-500 hover:text-accent-green transition-colors duration-200">{t('footer.gdpr')}</a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
